import dayjs from "dayjs"

import { DATE_FORMAT } from "../../../utils/date/date.ts"

export const CALENDAR_PATH = "/calendar"

/**
 * The Calendar opened on a specific meeting. The date rides along so the view
 * lands on the right page before the event id is resolved.
 */
export const calendarDeepLink = (
  date?: string | null,
  eventId?: string | null,
  opts?: { edit?: boolean }
): string => {
  const params = new URLSearchParams()
  if (date) params.set("date", date)
  if (eventId) params.set("event", eventId)
  if (opts?.edit) params.set("edit", "1")

  const query = params.toString()
  return query ? `${CALENDAR_PATH}?${query}` : CALENDAR_PATH
}

/**
 * FullCalendar turns a date it cannot parse into a null marker and only trips
 * over it later, inside its own date maths — so a hand-edited `?date=` took the
 * whole page down. Anything but the day `calendarDeepLink` writes is dropped
 * here and the calendar opens on today.
 */
export const parseCalendarFocusDate = (
  raw?: string | null
): string | null => (raw && dayjs(raw, DATE_FORMAT, true).isValid() ? raw : null)
